import ResumeImg from '../assets/resume.jpg';
import { motion } from 'framer-motion';

export default function Resume() {
  return (
    <section
      id="resume"
      className="min-h-screen w-full bg-primary flex items-center justify-center py-24 px-6"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-3xl shadow-2xl p-10 md:p-16 flex flex-col md:flex-row items-center gap-12 max-w-6xl w-full"
      >
        {/* Image */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="relative w-full md:w-1/2 flex justify-center"
        >
          <img
            src={ResumeImg}
            alt="Resume"
            className="rounded-[2rem] shadow-[0_20px_40px_rgba(255,255,255,0.1)] max-w-[300px] w-full border-4 border-white/10 transform transition-transform duration-300 hover:scale-105 hover:shadow-xl"
          />
          <div className="absolute top-0 left-0 w-full h-full rounded-[2rem] bg-pink-500/10 blur-xl opacity-20 -z-10" />
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="w-full md:w-1/2 text-white"
        >
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6 bg-gradient-to-r from-pink-400 via-fuchsia-400 to-purple-400 bg-clip-text text-transparent w-fit">
            Resume
          </h2>
          <p className="text-lg leading-relaxed text-gray-300 mb-6">
            You can view my <span className="text-purple-400 font-semibold">Resume</span> &nbsp;
           
            <a
              href="https://drive.google.com/file/d/18t8QvDpH8-EMVVv5a7MexBoew6N4WGsx/view?usp=drivesdk"
              target="_blank"
              rel="noopener noreferrer"
              className="button inline-block"
            >
              Download
            </a>
          </p>
        </motion.div>
      </motion.div>
    </section>
  );
}
